
import { supabase } from '@/integrations/supabase/client';

export const userLookupService = {
  async findUserByEmail(email: string) {
    console.log('=== USER LOOKUP SERVICE START ===');
    console.log('Looking up user by email:', email);
    
    // Clean the email input
    const cleanEmail = email.toLowerCase().trim();
    console.log('Cleaned email:', cleanEmail);
    
    try {
      // First, try using the database function to get user by email
      console.log('Attempting to use get_user_by_email function...');
      const { data: authUser, error: functionError } = await supabase
        .rpc('get_user_by_email', { user_email: cleanEmail });

      console.log('Function result:', { authUser, functionError });

      if (functionError) {
        console.error('Function error:', functionError);
        throw new Error(`Database function error: ${functionError.message}`);
      }

      if (!authUser || (Array.isArray(authUser) && authUser.length === 0)) {
        console.log('No user found in auth.users with email:', cleanEmail);
        throw new Error(`User with email "${email}" not found. Please ask them to create an account first and then try inviting them again.`);
      }

      // Handle both array and single object responses with proper typing
      const userId = Array.isArray(authUser) ? authUser[0]?.id : (authUser as any)?.id;
      console.log('Found user ID from auth:', userId);

      if (!userId) {
        console.error('No user ID found in response');
        throw new Error(`Invalid user data returned for email "${email}". Please ask them to create an account first.`);
      }

      // Now check if user has a profile
      console.log('Checking user profile...');
      const { data: profile, error: profileError } = await supabase
        .from('profiles')
        .select('id, email')
        .eq('id', userId)
        .maybeSingle();

      console.log('Profile lookup result:', { profile, profileError });

      if (profileError) {
        console.error('Profile lookup error:', profileError);
        // Continue anyway, as profile might not exist yet
      }

      console.log('=== USER LOOKUP SERVICE SUCCESS ===');
      return {
        userId: userId,
        email: cleanEmail
      };

    } catch (error: any) {
      console.error('=== USER LOOKUP SERVICE ERROR ===');
      console.error('Error details:', {
        message: error.message,
        code: error.code,
        details: error.details,
        hint: error.hint,
        stack: error.stack
      });
      throw error;
    }
  }
};
